import React, { createContext, useReducer } from 'react';
import gql from 'graphql-tag';
import client from '../utils/GQLClient';
import axios from 'axios';

const initialCreateState = {
  isCreated: false,
  isInitialised: false,
  user: null,
  users: null
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'INITIALISE': {
      const { isCreated, user } = action.payload;

      return {
        ...state,
        isCreated,
        isInitialised: true,
        user
      };
    }

    case 'UPDATE_INSTITUTION': {
      const { user, updatesuccessfull } = action.payload;

      return {
        ...state,
        updatesuccessfull,
        user
      };
    }
    case 'UPDATE_INSTITUTION_ERR': {
      const { err, updatesuccessfull } = action.payload;

      return {
        ...state,
        updatesuccessfull: false,
        err
      };
    }
    case 'ADD_IMPORT': {
      const { user1, updatesuccessfull1 } = action.payload;

      return {
        ...state,
        updatesuccessfull1,
        user1
      };
    }
    case 'ADD_IMPORT_ERROR': {
      const { err1, updatesuccessfull1 } = action.payload;

      return {
        ...state,
        updatesuccessfull1: false,
        err1
      };
    }
    default: {
      return { ...state };
    }
  }
};

const ImportForCompanySetupContext = createContext({
  ...initialCreateState,
  uploadExamSessions: () => Promise.resolve(),
  uploadExamQuestionPaper: () => Promise.resolve(),

  uploadMakeupExamQuestionPaper: () => Promise.resolve(),

  uploadExamMarks: () => Promise.resolve(),
  uploadExamMarksSubjectiveFirst: () => Promise.resolve(),
  uploadExamMakeupMarksObjective: () => Promise.resolve(),

  uploadExamMarksSubjectiveSecond: () => Promise.resolve(),
  uploadExamRVMarksSubjectiveSecond: () => Promise.resolve(),

  uploadExamMakeupBookletSubjective: () => Promise.resolve(),
  uploadExamMakeupMarksSubjective: () => Promise.resolve(),

  uploadExamMarksLab: () => Promise.resolve(),

  uploadSeating: () => Promise.resolve(),
  uploadOnlineSeating: () => Promise.resolve(),
  NotifyStaff:()=>Promise.resolve()
});

export const ImportCompanySetupProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialCreateState);

  const NotifyStaff = async data => {
    // console.log("hit")

    try {
      let response;
      if (process.env.REACT_APP_ENV === 'test') {
        response = await axios.post(
          'https://reportapidev.rovelabs.com/report/StaffWiseSessions',
          data
        );
      } else {
        response = await axios.post(
          'https://reportapi.rovelabs.com/report/StaffWiseSessions',
          data
        );
      }
      console.log('response',response);
      dispatch({
        type: 'UPDATE_INSTITUTION',
        payload: {
          user: response.data,
          updatesuccessfull: true
        }
      });
    } catch (err) {
      //  console.log(err);
      if (err.response) {
        console.log('response',err.response);

        dispatch({
          type: 'UPDATE_INSTITUTION_ERR',
          payload: {
            err: err.response.data,
            updatesuccessfull: false
          }
        });
      }
      //  console.log(err.message);
    }
  };

  const uploadSeating = async data => {
    // console.log("hit")

    try {
      let response;
      if (process.env.REACT_APP_ENV === 'test') {
        response = await axios.post(
          'https://3yj8easi7j.execute-api.ap-south-1.amazonaws.com/test/exam_seating',
          data
        );
      } else {
        response = await axios.post(
          'https://3yj8easi7j.execute-api.ap-south-1.amazonaws.com/prod/exam_seating',
          data
        );
      }
      console.log('response',response);
      dispatch({
        type: 'UPDATE_INSTITUTION',
        payload: {
          user: response.data,
          updatesuccessfull: true
        }
      });
    } catch (err) {
      //  console.log(err);
      if (err.response) {
        console.log('response',err.response);

        dispatch({
          type: 'UPDATE_INSTITUTION_ERR',
          payload: {
            err: err.response.data,
            updatesuccessfull: false
          }
        });
      }
      //  console.log(err.message);
    }
  };
  
  const uploadExamMarksLab = async data => {
    // console.log("hit")

    try {
      let response;
      if (process.env.REACT_APP_ENV === 'test') {
        response = await axios.post(
          'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/test/import_lab_marks',
          data
        );
      } else {
        response = await axios.post(
          'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/prod/import_lab_marks',
          data
        );
      }
      console.log('response',response);
      dispatch({
        type: 'UPDATE_INSTITUTION',
        payload: {
          user: response.data,
          updatesuccessfull: true
        }
      });
    } catch (err) {
      //  console.log(err);
      if (err.response) {
        console.log('response',err.response);

        dispatch({
          type: 'UPDATE_INSTITUTION_ERR',
          payload: {
            err: err.response.data,
            updatesuccessfull: false
          }
        });
      }
      //  console.log(err.message);
    }
  };

  const uploadExamMarksSubjectiveSecond = async data => {
    // console.log("hit")

    try {
      let response;
      if (process.env.REACT_APP_ENV === 'test') {
        response = await axios.post(
          'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/test/import_subjective_marks',
          data
        );
      } else {
        response = await axios.post(
          'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/prod/import_subjective_marks',
          data
        );
      }
      console.log('response',response);
      dispatch({
        type: 'UPDATE_INSTITUTION',
        payload: {
          user: response.data,
          updatesuccessfull: true
        }
      });
    } catch (err) {
      //  console.log(err);
      if (err.response) {
        console.log('response',err.response);

        dispatch({
          type: 'UPDATE_INSTITUTION_ERR',
          payload: {
            err: err.response.data,
            updatesuccessfull: false
          }
        });
      }
      //  console.log(err.message);
    }
  };

  const uploadExamRVMarksSubjectiveSecond = async data => {
    // console.log("hit")

    try {
      let response;
      if (process.env.REACT_APP_ENV === 'test') {
        response = await axios.post(
          'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/test/import_rv_marks',
          data
        );
      } else {
        response = await axios.post(
          'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/prod/import_rv_marks',
          data
        );
      }
      console.log('response',response);
      dispatch({
        type: 'UPDATE_INSTITUTION',
        payload: {
          user: response.data,
          updatesuccessfull: true
        }
      });
    } catch (err) {
      //  console.log(err);
      if (err.response) {
        console.log('response',err.response);

        dispatch({
          type: 'UPDATE_INSTITUTION_ERR',
          payload: {
            err: err.response.data,
            updatesuccessfull: false
          }
        });
      }
      //  console.log(err.message);
    }
  };

  const uploadExamMarksSubjectiveFirst = async data => {
    // console.log("hit")

    try {
      let response;
      if (process.env.REACT_APP_ENV === 'test') {
        response = await axios.post(
          'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/test/import_usn_booklet_data',
          data
        );
      } else {
        response = await axios.post(
          'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/prod/import_usn_booklet_data',
          data
        );
      }
      console.log('response',response);
      dispatch({
        type: 'UPDATE_INSTITUTION',
        payload: {
          user: response.data,
          updatesuccessfull: true
        }
      });
    } catch (err) {
      //  console.log(err);
      if (err.response) {
        console.log('response',err.response);

        dispatch({
          type: 'UPDATE_INSTITUTION_ERR',
          payload: {
            err: err.response.data,
            updatesuccessfull: false
          }
        });
      }
      //  console.log(err.message);
    }
  };








  const uploadExamMarks = async data => {
    // console.log("hit")

    try {
      let response;
      if (process.env.REACT_APP_ENV === 'test') {
        response = await axios.post(
          'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/test/import_objective_marks',
          data
        );
      } else {
        response = await axios.post(
          'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/prod/import_objective_marks',
          data
        );
      }
      console.log('response',response);
      dispatch({
        type: 'UPDATE_INSTITUTION',
        payload: {
          user: response.data,
          updatesuccessfull: true
        }
      });
    } catch (err) {
      //  console.log(err);
      if (err.response) {
        console.log('response',err.response);

        dispatch({
          type: 'UPDATE_INSTITUTION_ERR',
          payload: {
            err: err.response.data,
            updatesuccessfull: false
          }
        });
      }
      //  console.log(err.message);
    }
  };
  const uploadExamQuestionPaper = async data => {
    // console.log("hit")

    try {
      let response;
      if (process.env.REACT_APP_ENV === 'test') {
        response = await axios.post(
          'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/test/import_objective_qp',
          data
        );
      } else {
        response = await axios.post(
          'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/prod/import_objective_qp',
          data
        );
      }
      console.log('response',response);
      dispatch({
        type: 'UPDATE_INSTITUTION',
        payload: {
          user: response.data,
          updatesuccessfull: true
        }
      });
    } catch (err) {
      //  console.log(err);
      if (err.response) {
        console.log('response',err.response);

        dispatch({
          type: 'UPDATE_INSTITUTION_ERR',
          payload: {
            err: err.response.data,
            updatesuccessfull: false
          }
        });
      }
      //  console.log(err.message);
    }
  };

  const uploadMakeupExamQuestionPaper = async data => {
    // console.log("hit")

    try {
      let response;
      if (process.env.REACT_APP_ENV === 'test') {
        response = await axios.post(
          'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/test/import_objective_qp_makeup',
          data
        );
      } else {
        response = await axios.post(
          'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/prod/import_objective_qp_makeup',
          data
        );
      }
      console.log('response',response);
      dispatch({
        type: 'UPDATE_INSTITUTION',
        payload: {
          user: response.data,
          updatesuccessfull: true
        }
      });
    } catch (err) {
      //  console.log(err);
      if (err.response) {
        console.log('response',err.response);

        dispatch({
          type: 'UPDATE_INSTITUTION_ERR',
          payload: {
            err: err.response.data,
            updatesuccessfull: false
          }
        });
      }
      //  console.log(err.message);
    }
  };

  const uploadExamSessions = async data => {
    // console.log("hit")

    try {
      let response;
      if (process.env.REACT_APP_ENV === 'test') {
        response = await axios.post(
          'https://3yj8easi7j.execute-api.ap-south-1.amazonaws.com/test/exam_time_table_upload',
          data
        );
      } else {
        response = await axios.post(
          'https://3yj8easi7j.execute-api.ap-south-1.amazonaws.com/prod/exam_time_table_upload',
          data
        );
      }
      console.log('response',response);
      dispatch({
        type: 'UPDATE_INSTITUTION',
        payload: {
          user: response.data,
          updatesuccessfull: true
        }
      });
    } catch (err) {
      //  console.log(err);
      if (err.response) {
        console.log('response',err.response);

        dispatch({
          type: 'UPDATE_INSTITUTION_ERR',
          payload: {
            err: err.response.data,
            updatesuccessfull: false
          }
        });
      }
      //  console.log(err.message);
    }
  };


  const uploadOnlineSeating = async data => {
    // console.log("hit")

    try {
      let response;
      if (process.env.REACT_APP_ENV === 'test') {
        response = await axios.post(
          'https://3yj8easi7j.execute-api.ap-south-1.amazonaws.com/test/online_exam_seating',
          data
        );
      } else {
        response = await axios.post(
          'https://3yj8easi7j.execute-api.ap-south-1.amazonaws.com/prod/online_exam_seating',
          data
        );
      }
      console.log('response',response);
      dispatch({
        type: 'UPDATE_INSTITUTION',
        payload: {
          user: response.data,
          updatesuccessfull: true
        }
      });
    } catch (err) {
      //  console.log(err);
      if (err.response) {
        console.log('response',err.response);

        dispatch({
          type: 'UPDATE_INSTITUTION_ERR',
          payload: {
            err: err.response.data,
            updatesuccessfull: false
          }
        });
      }
      //  console.log(err.message);
    }
  };

  const uploadExamMakeupBookletSubjective = async data => {
    // console.log("hit")

    try {
      let response;
      if (process.env.REACT_APP_ENV === 'test') {
        response = await axios.post(
          'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/test/import_usn_booklet_data_makeup',
          data
        );
      } else {
        response = await axios.post(
          'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/prod/import_usn_booklet_data_makeup',
          data
        );
      }
      console.log('response',response);
      dispatch({
        type: 'UPDATE_INSTITUTION',
        payload: {
          user: response.data,
          updatesuccessfull: true
        }
      });
    } catch (err) {
      //  console.log(err);
      if (err.response) {
        console.log('response',err.response);

        dispatch({
          type: 'UPDATE_INSTITUTION_ERR',
          payload: {
            err: err.response.data,
            updatesuccessfull: false
          }
        });
      }
      //  console.log(err.message);
    }
  };

  const uploadExamMakeupMarksSubjective = async data => {
    // console.log("hit")

    try {
      let response;
      if (process.env.REACT_APP_ENV === 'test') {
        response = await axios.post(
          'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/test/import_subjective_marks_makeup',
          data
        );
      } else {
        response = await axios.post(
          'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/prod/import_subjective_marks_makeup',
          data
        );
      }
      console.log('response',response);
      dispatch({
        type: 'UPDATE_INSTITUTION',
        payload: {
          user: response.data,
          updatesuccessfull: true
        }
      });
    } catch (err) {
      //  console.log(err);
      if (err.response) {
        console.log('response',err.response);

        dispatch({
          type: 'UPDATE_INSTITUTION_ERR',
          payload: {
            err: err.response.data,
            updatesuccessfull: false
          }
        });
      }
      //  console.log(err.message);
    }
  };

  const uploadExamMakeupMarksObjective = async data => {
    // console.log("hit")

    try {
      let response;
      if (process.env.REACT_APP_ENV === 'test') {
        response = await axios.post(
          'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/test/import_objective_marks_makeup',
          data
        );
      } else {
        response = await axios.post(
          'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/prod/import_objective_marks_makeup',
          data
        );
      }
      console.log('response',response);
      dispatch({
        type: 'UPDATE_INSTITUTION',
        payload: {
          user: response.data,
          updatesuccessfull: true
        }
      });
    } catch (err) {
      //  console.log(err);
      if (err.response) {
        console.log('response',err.response);

        dispatch({
          type: 'UPDATE_INSTITUTION_ERR',
          payload: {
            err: err.response.data,
            updatesuccessfull: false
          }
        });
      }
      //  console.log(err.message);
    }
  };

  const uploadExamCourses = async data => {
    // console.log("hit")

    try {
      let response;
      if (process.env.REACT_APP_ENV === 'test') {
        response = await axios.post(
          'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/test/import_exam_courses',
          data
        );
      } else {
        response = await axios.post(
          'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/prod/import_exam_courses',
          data
        );
      }
      console.log('response',response);
      dispatch({
        type: 'UPDATE_INSTITUTION',
        payload: {
          user: response.data,
          updatesuccessfull: true
        }
      });
    } catch (err) {
      //  console.log(err);
      if (err.response) {
        console.log('response',err.response);

        dispatch({
          type: 'UPDATE_INSTITUTION_ERR',
          payload: {
            err: err.response.data,
            updatesuccessfull: false
          }
        });
      }
      //  console.log(err.message);
    }
  };

  return (
    <ImportForCompanySetupContext.Provider
      value={{
        ...state,
        uploadExamMarks,
        uploadExamQuestionPaper,
        uploadMakeupExamQuestionPaper,
        uploadExamSessions,
        uploadSeating,
        uploadOnlineSeating,
        uploadExamMarksLab,
        uploadExamMarksSubjectiveSecond,
        uploadExamRVMarksSubjectiveSecond,
        uploadExamMarksSubjectiveFirst,
        NotifyStaff,
        uploadExamMakeupMarksObjective,
        uploadExamMakeupBookletSubjective,
        uploadExamMakeupMarksSubjective,
        uploadExamCourses
      }}
    >
      {children}
    </ImportForCompanySetupContext.Provider>
  );
};

export default ImportForCompanySetupContext;
